// extracted by mini-css-extract-plugin
export default {"productDevelopmentCard":"ProductDevelopment_productDevelopmentCard__pzKE5"};